// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "item-28508";
var _3 = "passengerName-3Z2jR";
var _4 = "money-1wiy-";
var _5 = "item_active-2s-90";
var _6 = "avatar-1a1sP";
var _7 = "clear-1zif3";
var _8 = "item_recommend-fwADI";
export { _1 as "__esModule", _2 as "item", _3 as "passengerName", _4 as "money", _5 as "item_active", _6 as "avatar", _7 as "clear", _8 as "item_recommend" }
export default { "__esModule": _1, "item": _2, "passengerName": _3, "money": _4, "item_active": _5, "avatar": _6, "clear": _7, "item_recommend": _8 }
